import { ArrowDownIcon } from '@heroicons/react/24/outline';
import { Button, formatPrice } from '@retainerclub/common';
import { useLocale } from '@retainerclub/hooks';
import PropTypes from 'prop-types';

function CurrentSubscriptionDowngrade({ downgrades, handleDowngrade }) {
  const { locale } = useLocale();

  return downgrades.length > 0 ? (
    <div>
      <h4 className="mb-3 font-semibold text-gray-900 text-md">
        Downgrade Options
      </h4>
      <div className="space-y-3">
        {downgrades.map((tier) => (
          <div
            key={tier.id}
            className="flex items-center justify-between rounded-lg border border-amber-600 bg-amber-50 p-4"
          >
            <div className="flex items-center space-x-3">
              <ArrowDownIcon className="h-5 w-5 text-yellow-600" />
              <div>
                <h5 className="font-medium text-yellow-800">
                  {tier.product.name}
                </h5>
                <p className="text-2xl text-gray-600">
                  <span className="font-bold text-yellow-900">
                    {formatPrice(
                      tier.overPrice ? tier.price : tier.product.price,
                      locale,
                    )}{' '}
                  </span>{' '}
                  <span className="text-gray-600 text-sm">/ year</span>
                </p>

                <ul className="mt-1 ml-2 list-inside list-disc text-gray-500 text-xs">
                  {tier.product.productFeatures.slice(0, 4).map((feature) => (
                    <li key={feature.id}>{feature.text}</li>
                  ))}
                </ul>
              </div>
            </div>
            <Button
              name="Downgrade"
              size="sm"
              color="yellow"
              rounded
              onClick={() => handleDowngrade(tier)}
            />
          </div>
        ))}
      </div>
    </div>
  ) : null;
}

CurrentSubscriptionDowngrade.propTypes = {
  downgrades: PropTypes.array.isRequired,
};

export default CurrentSubscriptionDowngrade;
